import { render } from "./Outfit.vue?vue&type=template&id=22847a24"
import script from "./Outfit.vue?vue&type=script&lang=js"
export * from "./Outfit.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\jekr\\Documents\\arla-foods-sc-event-platform\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__